import "core-js/modules/es6.regexp.search.js";
var url = {
  /**
   * URL params
   *
   * // ?type=product&id=1234
   * urlParams.has('type');  // true
   * urlParams.get('id');    // 1234
   * urlParams.getAll('id'); // ["1234"]
   * urlParams.toString();   // type=product&id=1234
   */
  params: new URLSearchParams(window.location.search),
  /**
   * Remove hash from the URL.
   * Used for tabs mostly.
   */
  removeHash: function removeHash() {
    var scrollV,
      scrollH,
      loc = window.location;
    if ('pushState' in history) {
      history.pushState('', document.title, loc.pathname + loc.search);
    } else {
      // Prevent scrolling by storing the page's current scroll offset
      scrollV = document.body.scrollTop;
      scrollH = document.body.scrollLeft;
      loc.hash = '';

      // Restore the scroll offset, should be flicker free
      document.body.scrollTop = scrollV;
      document.body.scrollLeft = scrollH;
    }
  }
};
export default url;